import { CacheConfig } from '../base/define';
import { formatCurrentTime } from './format';

const config: CacheConfig = {
  'get-system-time': {
    url: '/api/steam/system/getTime',
    method: 'get',
    format: formatCurrentTime,
  },
  'update-trace-name': {
    url: '/api/steam/school/getTraceName',
    method: 'get',
  },
  'report-log': {
    url: '/api/steam/config/reportLog',
    method: 'post',
  },
  'send-sms': {
    url: '/api/steam/sms/send',
    method: 'post',
  },
  'verify-sms': {
    url: '/api/steam/sms/checkMobileCode',
    method: 'post',
  },
};

export default config;
